// extracted by mini-css-extract-plugin
module.exports = {"Recorder":"MemoRecorder_Recorder__32kIY"};